import { render, staticRenderFns } from "./QuizDisplay.vue?vue&type=template&id=0c22237a"
import script from "./QuizDisplay.vue?vue&type=script&lang=js"
export * from "./QuizDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports